<template>
    <div class="timeline-container">
        <timelinefilterstabs
            v-if="tabs && tabs.length > 0 && filtersReady && !isDocument"
            :activeTab="activeTab"
            :tabs="tabs"
            :counters="counters"
            @update:activeTab="(tab) => (activeTab = tab)"
            @applyFilter="applyFilter"
        />

        <TimelineFilters
            v-if="useFilters && filtersReady && !isDocument"
            v-show="showFilter"
            :value="entitiesGroups"
            :presetDate="presetDate"
            @applyFilter="applyFilter"
            @resetFilter="resetFilter"
        />

        <TimelineEmailFilters
            v-if="showEmailFilters || isDocument"
            :activeFilter="activeEmailFilter"
            class="timeline-filters"
            @filterUpdate="handleEmailFilterUpdate"
        />

        <TimelineAnnotationFilters
            v-if="showAnnotationFilters"
            :activeFilter="activeAnnotationFilter"
            :overviewType="overviewType"
            class="timeline-filters"
            @filterUpdate="handleAnnotationFilterUpdate"
        />

        <div class="cd-container mt-0 flex-column timeline-container" @scroll="onScroll">
            <!-- TIMELINE -->
            <section id="cd-timeline">
                <!-- INCOMING EVENTS -->
                <div v-if="incomingLogs && incomingLogs.length > 0" class="incoming-events">
                    <div class="cd-timeline-log--title">
                        <div v-if="incomingLogs.length > 0" class="cd-timeline-day-wrapper">
                            <div class="cd-timeline-day-label semibold">
                                <span>
                                    {{ $l10n.p__('Timeline', 'A venir') }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="cd-timeline-more">
                        <div v-if="!loaderIncoming" class="ml-6">
                            <a
                                v-if="pagination.incoming.seeMore"
                                class="link"
                                href="javascript:;"
                                @click="fetch(false, true)"
                            >
                                <span>{{ $l10n.__("Voir plus d'éléments d'activité") }}</span>
                            </a>
                        </div>
                        <div v-else class="loader-container prelative aleft py-3">
                            <preloader :display="loaderIncoming" size="small" :background="false" />
                        </div>
                    </div>

                    <div
                        class="flex-column timeline-overflow-y"
                        :class="{ 'cd-timeline--overflow': isOverflowing(orderedIncomingLogs) }"
                    >
                        <div
                            v-for="(log, indexLog) in orderedIncomingLogs"
                            :key="indexLog"
                            :class="{
                                'cd-timeline-log': true,
                                'cd-timeline-log--object': log.cardType === 'object',
                            }"
                        >
                            <div
                                :class="
                                    'cd-timeline-block block-' + log.type + ' card-' + log.cardType
                                "
                            >
                                <component
                                    :is="getComponent(log)"
                                    class="flex"
                                    :oneLog="log"
                                    :isDocument="isDocument"
                                    :linkedtype="linkedtype"
                                    :linkedid="linkedid"
                                    :overviewType="overviewType"
                                    @changeLog="(e) => updateIncomingLog(e, log)"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- PAST EVENTS -->
                <div
                    v-if="orderedLogs && orderedLogs.length > 0"
                    class="past-events flex-column"
                    :class="{ 'cd-timeline--overflow': isOverflowing(orderedLogs) }"
                >
                    <div
                        v-for="(log, indexLog) in orderedLogs"
                        :key="indexLog"
                        :class="{
                            'cd-timeline-log': true,
                            'cd-timeline-log--object': log.cardType === 'object',
                            'cd-timeline-log--annual': log.displayYear,
                            'cd-timeline-log--day': log.displayDate,
                        }"
                    >
                        <!-- LINE -->
                        <div v-if="log.displayYear" class="annual-line-block">
                            <h2 class="annual-line">
                                {{ log.displayYear }}
                            </h2>
                        </div>
                        <div v-if="log.displayDate" class="cd-timeline-day-wrapper">
                            <div class="cd-timeline-day-label semibold">
                                <span>
                                    {{
                                        $filters.dateFormatter(log.timestamp, 'NORMAL_MONTH', false)
                                    }}
                                </span>
                            </div>
                        </div>
                        <div
                            :class="{
                                'cd-timeline-block': true,
                                'flex-level': log.cardType !== 'object',
                            }"
                        >
                            <TimelineSystemIcon
                                v-if="log.cardType !== 'object'"
                                :log="log"
                                class="timeline-icon"
                            />
                            <component
                                :is="getComponent(log)"
                                :id="log.objectid"
                                :ref="getRefType(log)"
                                :key="log.objectid"
                                :isDocument="isDocument"
                                :overviewType="overviewType"
                                class="flex"
                                :linkedid="linkedid"
                                :linkedtype="linkedtype"
                                :oneLog="log"
                                :isPinnable="'staff' !== linkedtype"
                                @changeLog="(e) => updateLog(e, log)"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <!-- MORE -->
            <div class="cd-timeline-more gray-60 fs-3">
                <div v-if="!loader">
                    <CompassButton
                        v-if="pagination.past.seeMore"
                        :label="$t.__('timeline.Timeline.view_more_activity_items')"
                        type="tertiary"
                        @click="fetch(true, false)"
                    />
                    <p v-else class="m-0 semibold pl-5">{{ errorMessage }}</p>
                </div>
                <div v-else class="loader-container prelative mt-5 py-3">
                    <preloader :display="loader" size="small" :background="false" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Preloader from 'vcomponents/utilities/Preloader.vue';
import { getFullNameUser } from 'Helpers/avatarHelper';
import TimelineFilters from './TimelineFilters.vue';
import TimelineFiltersTabs from './TimelineFiltersTabs.vue';
import TimelineDefaultCard from './TimelineDefaultCard.vue';
import TimelineConsentCard from './timelineconsentcard/TimelineConsentCard.vue';
import TimelinePrimaryCard from './TimelinePrimaryCard.vue';
import AnnotationCard from './AnnotationCard.vue';
import TaskCard from './TaskCard.vue';
import EventCard from './EventCard.vue';
import PhoneCallCard from './PhoneCallCard.vue';
import EmailCard from './EmailCard.vue';
import EmailCardV2 from 'vcomponents/timeline/EmailCardV2.vue';
import LogCard from './LogCard.vue';
import SnippetTrackingCard from './SnippetTrackingCard.vue';
import CustomActivityCard from './CustomActivityCard.vue';
import TimelineSystemIcon from './TimelineSystemIcon.vue';
import TimelineEmailFilters from 'vcomponents/timeline/TimelineEmailFilters.vue';
import MarketingCard from './MarketingCard.vue';
import Feature from 'Services/Feature';
import TimelineAnnotationFilters from 'vcomponents/timeline/TimelineAnnotationFilters.vue';
import _ from 'lodash';

import IconMixin from '../../mixins/IconMixin';
import TimelineFiltersLoader from './TimelineFiltersLoader';
import { createNamespacedHelpers } from 'vuex';
import LocalStorage from 'Core/commons/LocalStorage';
import { isNil } from 'lodash';
import { fetchActivitiesCrmMetas } from 'api/activities/activitiesService';
import ActivitiesStore from 'stores/activitiesStore.js';
import { deleteEmailById } from 'api/emailEngine/emailEngineService';

const { mapState } = createNamespacedHelpers('corp');
const { mapGetters } = createNamespacedHelpers('user');
const { mapActions } = createNamespacedHelpers('activitiesStores');

export default {
    components: {
        TimelineFilters,
        timelinefilterstabs: TimelineFiltersTabs,
        timelinedefaultcard: TimelineDefaultCard,
        timelineprimarycard: TimelinePrimaryCard,
        timelineannotationcard: AnnotationCard,
        timelinetaskcard: TaskCard,
        timelineeventcard: EventCard,
        timelinephonecallcard: PhoneCallCard,
        timelineemailcard: EmailCard,
        timelineemailcardv2: EmailCardV2,
        timelinelogcard: LogCard,
        Preloader,
        timelinesnippettrackingcard: SnippetTrackingCard,
        timelinecustomactivitycard: CustomActivityCard,
        TimelineSystemIcon,
        TimelineEmailFilters,
        TimelineAnnotationFilters,
        timelinemarketingcard: MarketingCard,
        timelineconsentcard: TimelineConsentCard,
    },
    mixins: [IconMixin],
    props: {
        overviewType: {
            type: String,
            required: true,
        },
        linkedtype: {
            type: String,
            required: true,
        },
        linkedid: {
            type: Number,
            required: true,
        },
        useFilters: {
            type: Boolean,
            required: false,
            default: true,
        },
        isDocument: {
            type: Boolean,
            default: false,
            required: false,
        },
        forceTab: {
            type: String,
            default: '',
            required: false,
        },
    },
    data() {
        return {
            logs: [],
            incomingLogs: [],
            counters: {},
            countersBuffer: null,
            pagination: {
                past: {
                    page: 1,
                    nbPerPage: 20,
                    offsets: [],
                    seeMore: false,
                },
                incoming: {
                    page: 1,
                    nbPerPage: 20,
                    offsets: [],
                    seeMore: false,
                },
            },
            dates: [],
            error: {},
            newFilters: {
                entities: [],
                event: '',
                start: '',
                end: '',
                currentTab: 'activity',
                pinned: false,
            },
            loader: true,
            loaderIncoming: true,
            processing: false,
            firstCall: true,
            showFilter: true,
            presetFilters: {},
            entities: [],
            entitiesGroups: [],
            tabs: [],
            defaultEntities: [],
            forcedLabel: [],
            filtersReady: false,
            activeTab: 'activity',
            forceTimelineFiltersTabs: '',
            presetDate: [],
            firstCallIncomingNbPerPage: 2,
            excludeLogTypesFromCheck: ['email.sent'],
            commentExist: false,
            commentToRedirect: null,
            emailExist: false,
            emailToRedirect: null,
            localstorage: new LocalStorage('email', 'active-email-filter'),
            activeEmailFilter: ['all'],
            activeAnnotationFilter: ['all'],
        };
    },
    computed: {
        ...mapGetters(['getUser']),
        showEmailFilters() {
            return this.activeTab === 'email' && Feature.isEnabled('email-engine');
        },
        showAnnotationFilters() {
            return this.activeTab === 'note';
        },
        errorMessage() {
            if (!this.error || !this.error.code) {
                return this.$l10n.__(
                    "Nous n'avons pas trouvé d'informations supplémentaires à vous afficher",
                );
            }

            switch (this.error.code) {
                case 403:
                    return this.$l10n.__('Ce service est momentanément indisponible');
                default:
                    return this.$l10n.__(
                        "Nous n'avons pas trouvé d'informations supplémentaires à vous afficher",
                    );
            }
        },

        orderedLogs() {
            var dates = [];
            var logs = _.orderBy(this.logs, 'timestamp', 'desc');
            var nowYear = moment().format('YYYY');
            var nowMouth = moment().startOf('month').unix();

            for (var i in logs) {
                logs[i].displayDate = false;
                logs[i].displayYear = false;

                var logStartDate = moment(logs[i].timestamp, 'X');
                var logStartDateTimestamp = logStartDate.startOf('month').unix();

                if (!dates.includes(logStartDateTimestamp) && nowMouth !== logStartDateTimestamp) {
                    dates.push(logStartDateTimestamp);
                    logs[i].displayDate = true;
                }

                var year = logStartDate.format('YYYY');

                if (!dates.includes(year)) {
                    dates.push(year);
                    logs[i].displayYear = year === nowYear ? this.$l10n.__('Récemment') : year;
                }
            }
            return logs;
        },

        orderedIncomingLogs() {
            return _.orderBy(this.incomingLogs, 'timestamp', 'desc');
        },

        ...mapState(['timeformat']),
    },
    async created() {
        if (!this.$store.state.activitiesStores) {
            this.$store.registerModule('activitiesStores', ActivitiesStore);
        }
        const { data: metas } = await fetchActivitiesCrmMetas();
        this.updateMetasData(metas);

        const getUrlParams = new URLSearchParams(window.location.search);
        const getParamTimelineFiltersTabs = getUrlParams.get('redirectTab');

        // the timeline was added in doc overview only to view emails
        // We force this variable, because the state fetched from the server (fetchPresetFilters) can be wrong.
        if (this.isDocument) {
            this.activeTab = 'email';
            this.forceTimelineFiltersTabs = 'email';
        } else if (this.forceTab) {
            this.activeTab = this.forceTab;
            this.forceTimelineFiltersTabs = this.forceTab;
        } else if (getParamTimelineFiltersTabs && Feature.isEnabled('email-engine')) {
            this.forceTimelineFiltersTabs =
                getParamTimelineFiltersTabs === 'emailreceived' ||
                getParamTimelineFiltersTabs === 'emailsent'
                    ? 'email'
                    : getParamTimelineFiltersTabs;
        }
        this.activeTab = this.forceTimelineFiltersTabs;
        const timelineFiltersLoader = new TimelineFiltersLoader(this.linkedtype);
        const mappingName = this.linkedtype.substr(0, 1).toUpperCase() + this.linkedtype.substr(1);
        const { entitiesTabs, defaultEntities, forcedLabel } = require(
            `../overview/tabs/mapping/${mappingName}Mapping`,
        );

        timelineFiltersLoader.load().then((result) => {
            this.entitiesGroups = result.entitiesGroups;
            this.entities = result.entities;
            this.tabs = entitiesTabs;
            this.defaultEntities = defaultEntities;
            this.forcedLabel = forcedLabel;
            if (this.forcedLabel.length > 0) {
                this.forceLabelEntities();
            }

            this.fetchPresetFilters();
        });

        if (Feature.isEnabled('email-engine')) {
            if (getParamTimelineFiltersTabs === 'emailreceived') {
                this.activeEmailFilter = ['emailengine.received', 'email.received'];
            } else if (getParamTimelineFiltersTabs === 'emailsent') {
                this.activeEmailFilter = [
                    'emailengine.sent',
                    'emailengine.sending.failed',
                    'email.sent',
                ];
            } else if (!isNil(this.localstorage.get())) {
                this.activeEmailFilter = this.localstorage.get();
            }
        }
        EventBus.on('timeline:toggle-pin', this.togglePin);
        EventBus.on('delete:email', this.handleEmailDelete);
    },
    async mounted() {
        EventBus.on('timeline:processAndAdd', ({ entity, event, objectid, eventDetails }) => {
            eventDetails = eventDetails === undefined ? {} : eventDetails;

            if (!this.newFilters.entities.includes(entity)) {
                return;
            }

            window.SellsyJS.WebServiceCaller.post(
                `/timeline/process/${this.getLinkedType()}/${this.linkedid}/${event}/${objectid}`,
                {},
                { eventDetails: eventDetails },
                (response) => {
                    this.addLogs(response);
                },
            );
        });

        EventBus.on('refreshTimeline', () => {
            this.firstCall = true;
        });

        EventBus.on('timeline:add', ({ entity, payload }) => {
            if (!this.newFilters.entities.includes(entity)) {
                return;
            }

            if (entity === 'annotation') {
                this.adaptAnnotation(payload.data);
            } else {
                this.addLogs(payload);
            }
        });

        EventBus.on('timeline:refreshLog', ({ objectType, objectId }) => {
            for (const i in this.logs) {
                if (
                    this.logs[i].objecttype === objectType &&
                    this.logs[i].objectid === objectId &&
                    this.logs[i].event
                ) {
                    this.refreshLog('past', i);
                }
            }

            for (const i in this.incomingLogs) {
                if (
                    this.incomingLogs[i].objecttype === objectType &&
                    this.incomingLogs[i].objectid === objectId &&
                    this.incomingLogs[i].event
                ) {
                    this.refreshLog('incoming', i);
                }
            }
        });

        EventBus.on('timeline:deleteLog', ({ objectType, objectId }) => {
            for (const i in this.logs) {
                if (
                    this.logs[i].objecttype === objectType &&
                    this.logs[i].objectid === objectId &&
                    this.logs[i].event
                ) {
                    this.deleteLog('past', i, objectType);
                }
            }

            for (const i in this.incomingLogs) {
                if (
                    this.incomingLogs[i].objecttype === objectType &&
                    this.incomingLogs[i].objectid === objectId &&
                    this.incomingLogs[i].event
                ) {
                    this.deleteLog('incoming', i, objectType);
                }
            }
        });

        EventBus.on('email:sent', ({ emailId, eventDetails }) => {
            EventBus.emit('timeline:processAndAdd', {
                entity: 'email',
                event: 'email.sent',
                objectid: emailId,
                eventDetails,
            });
        });

        EventBus.on('email:scheduled', ({ emailId, eventDetails }) => {
            EventBus.emit('timeline:processAndAdd', {
                entity: 'email',
                event: 'email.scheduled.created',
                objectid: emailId,
                eventDetails,
            });
        });

        EventBus.on('timeline:fetch-past-log', () => {
            if (this.pagination.past.seeMore) {
                this.fetch(true, false);
            }
        });

        const debounceActivity = _.debounce(this.fetchCounters, 1000);

        EventBus.on('sse:activity', (event) => {
            const filter = this.getLinkedType() + '.' + this.linkedid;

            if (
                !event.activity_filters.includes(filter) &&
                !event.activity_filters.includes(filter + '.nok')
            ) {
                return;
            }

            debounceActivity();
        });

        EventBus.on('timeline:refresh', () => {
            this.resetFilter();
        });

        EventBus.on('timeline:addMockedLog', (payload) => {
            if (this.activeEmailFilter[0] !== 'emailengine.received') {
                this.addMockedLog(payload);
            }
        });

        EventBus.on('timeline:refreshCounter', (count) => {
            if (count.label?.length > 0) {
                this.updateDisplayedTabCounter(count.label, count.addedValue);
                if (count.addedValue < 0 && this.newFilters.currentTab === 'pinned') {
                    const removeLog = this.logs.findIndex((log) => log.objectid === count.objectid);
                    if (removeLog >= 0) this.logs.splice(removeLog, 1);

                    const removeIncomingLog = this.incomingLogs.findIndex(
                        (log) => log.objectid === count.objectid,
                    );
                    if (removeIncomingLog >= 0) this.incomingLogs.splice(removeIncomingLog, 1);
                }
            }
        });
    },

    beforeUnmount() {
        EventBus.off('sse:activity');
        EventBus.off('timeline:processAndAdd');
        EventBus.off('refreshTimeline');
        EventBus.off('timeline:add');
        EventBus.off('timeline:refreshLog');
        EventBus.off('timeline:deleteLog');
        EventBus.off('email:sent');
        EventBus.off('email:scheduled');
        EventBus.off('timeline:fetch-past-log');
        EventBus.off('timeline:addMockedLog');
        EventBus.off('timeline:toggle-pin');
        EventBus.off('delete:email', this.handleEmailDelete);

        if (this.$route.query.email) {
            const emailsTohighlight = this.$refs['email' + this.$route.query.email][0];
            emailsTohighlight.$el.classList.remove('highlighted');
        }
    },

    methods: {
        ...mapActions(['updateMetasData']),

        handleEmailDelete($event) {
            deleteEmailById($event.id)
                .then(() => {
                    this.$pushToast({
                        close: true,
                        text: this.$t.__('email.ScheduledEmailListing.email_deleted'),
                        type: 'success',
                    });

                    EventBus.emit('timeline:deleteLog', {
                        objectType: 'emailengine',
                        objectId: $event.id,
                    });
                })
                .catch((error) => {
                    this.$pushToast({
                        close: true,
                        text: error,
                        type: 'error',
                    });
                });
        },
        getComponent(log) {
            const type = log.card;
            if (
                type === 'email' &&
                Feature.isEnabled('email-engine') &&
                log?.email?.provider === 'nylas'
            ) {
                return 'timelineemailcardv2';
            }
            return `timeline${type}card`;
        },
        getRefType(log) {
            return log.card === 'email' ? `email.${log.objectid}` : `comment${log.objectid}`;
        },
        handleEmailFilterUpdate(newFilter) {
            if (newFilter.includes('emailengine.sent')) {
                newFilter.push('emailengine.sending.failed', 'email.sent');
            } else if (newFilter.includes('emailengine.received')) {
                newFilter.push('email.received');
            }
            this.applyFilter({
                ...this.newFilters,
                filters: {
                    ...this.newFilters.filters,
                    events: !newFilter.includes('all') // in case of all, the backend requires an empty string
                        ? newFilter
                        : null,
                },
            });
            this.activeEmailFilter = newFilter;
            this.localstorage.set(newFilter);
        },
        handleAnnotationFilterUpdate(newFilter) {
            this.activeAnnotationFilter = newFilter;
            this.applyFilter(this.newFilters);
        },
        updateIncomingLog(e, oneLog) {
            const index = this.incomingLogs.findIndex((log) => log.objectid === oneLog.objectid);
            const log = {
                ...this.incomingLogs[index],
                ...e,
            };
            this.incomingLogs[index] = log;
        },
        updateLog(e) {
            const index = this.logs.findIndex((log) => log.objectid === e.objectid);
            if (index === -1) {
                const index = this.incomingLogs.findIndex((log) => log.objectid === e.objectid);
                const log = {
                    ...this.incomingLogs[index],
                    ...e,
                };
                this.incomingLogs[index] = log;
            } else {
                const log = {
                    ...this.logs[index],
                    ...e,
                };

                this.logs[index] = log;
            }
        },

        fetch(pastSearch = true, incomingSearch = true) {
            if (!this.processing) {
                this.processing = true;

                const pagination = {};
                if (pastSearch) {
                    pagination.past = this.pagination.past;
                    this.loader = true;
                }
                if (incomingSearch) {
                    pagination.incoming = this.pagination.incoming;
                    this.loaderIncoming = true;
                }
                //At the first call, retrieves only 2 incoming logs
                if (pastSearch && incomingSearch) {
                    pagination.incoming = Object.assign({}, pagination.incoming);
                    pagination.incoming.nbPerPage = this.firstCallIncomingNbPerPage;
                }

                const newFilters = { ...this.newFilters };

                // force pinned tab to be recognized as 'activity' because
                //'pinned' tab category doesnt exist on enum choice on the api
                newFilters.currentTab =
                    newFilters.currentTab === 'pinned' ? 'activity' : newFilters.currentTab;

                axios
                    .post('/timeline', {
                        action: 'fetch',
                        linkedtype: this.linkedtype,
                        linkedid: this.linkedid,
                        pagination: pagination,
                        filters: newFilters,
                        firstCall: this.firstCall,
                    })
                    .then((response) => {
                        this.error = {};
                        this.updateTimeline(response.data);
                        if (response.data.error) {
                            window.Push.error(response.data.error);
                        }
                    })
                    .catch((error) => {
                        this.pagination.past.seeMore = false;
                        this.pagination.incoming.seeMore = false;
                        this.error = error.response?.data?.error;
                    })
                    .finally(() => {
                        this.loader = false;
                        this.loaderIncoming = false;
                        this.processing = false;
                        this.firstCall = false;
                        if (this.$route.query.comment && this.orderedLogs.length > 0) {
                            this.commentToRedirect = parseInt(this.$route.query.comment);

                            if (this.commentExist) {
                                this.highlightCard('comment', this.commentToRedirect);
                            } else {
                                ApiClient.post(
                                    '/activities/search',
                                    {},
                                    {
                                        filters: {
                                            entity: {
                                                type: 'comment',
                                                id: this.commentToRedirect,
                                            },
                                        },
                                    },
                                )
                                    .then((response) => {
                                        if (response.data.data.length > 0) {
                                            if (
                                                response.data.data[0].object.model.parent_id &&
                                                response.data.data[0].object.model.parent_id !== 0
                                            ) {
                                                this.commentToRedirect =
                                                    response.data.data[0].object.model.parent_id;
                                            }
                                            this.commentExist = true;
                                            this.highlightCard('comment', this.commentToRedirect);
                                        } else {
                                            this.commentExist = false;
                                        }
                                    })
                                    .catch(() => {
                                        this.commentExist = false;
                                    });
                            }
                        } else if (this.$route.query.email && this.orderedLogs.length > 0) {
                            this.highlightCard('email', this.$route.query.email);
                        }
                    });
            }
        },

        fetchCounters() {
            if (!Feature.isEnabled('activity-log-counters')) {
                return;
            }

            const { mapping } = require(`./CountersMapping`);

            const entities = [];
            for (const key in mapping) {
                entities.push(mapping[key].entity);
            }
            const filters = Object.assign({}, this.newFilters, { entities: entities });
            delete filters.objectRefType;
            delete filters.filters;
            axios
                .post('/timeline/counters', {
                    linkedtype: this.linkedtype,
                    linkedid: this.linkedid,
                    filters: filters,
                })
                .then((response) => {
                    const counters = {};

                    for (const tabName in mapping) {
                        const countersName = mapping[tabName].counter;

                        if (response.data.hasOwnProperty(countersName)) {
                            counters[tabName] = Object.assign({}, mapping[tabName], {
                                count: response.data[countersName],
                            });
                        }
                    }
                    this.counters = counters;
                })
                .catch(() => {
                    //Capture the errors, so as not to prevent the timeline from loading
                });
        },

        updateTimeline(data) {
            if (data.offsets.past) {
                this.pagination.past.offsets = data.offsets.past;
                this.pagination.past.page++;
                this.pagination.past.seeMore = data.offsets.past.length > 0;
            }

            if (data.offsets.incoming) {
                this.pagination.incoming.offsets = data.offsets.incoming;
                this.pagination.incoming.page++;
                this.pagination.incoming.seeMore = data.offsets.incoming.length > 0;
            }

            if (!_.isEmpty(data.timeline)) {
                if (data.timeline.past && data.timeline.past.length > 0) {
                    _.each(
                        data.timeline.past,
                        function (oneLog) {
                            this.logs.push(oneLog);
                        }.bind(this),
                    );
                }

                if (data.timeline.incoming && data.timeline.incoming.length > 0) {
                    _.each(
                        data.timeline.incoming,
                        function (oneLog) {
                            this.incomingLogs.push(oneLog);
                        }.bind(this),
                    );
                }
            }
        },
        applyFilter(newFilters) {
            this.newFilters = newFilters;
            if (this.activeTab === 'note') {
                let objectRefType = null;
                if (this.activeAnnotationFilter.includes('third')) {
                    objectRefType = ['client', 'prospect', 'supplier', 'individual'];
                } else if (!this.activeAnnotationFilter.includes('all')) {
                    objectRefType = this.activeAnnotationFilter;
                }
                this.newFilters = {
                    ...this.newFilters,
                    objectRefType,
                };
            }
            if (newFilters.currentTab) {
                if (newFilters.currentTab === 'activity') {
                    // push only entities already checked
                    this.newFilters.entities = this.getCheckedEntities();
                }
                this.newFilters.currentTab = newFilters.currentTab;
            } else {
                this.newFilters.currentTab = 'activity';
            }
            this.checkTab();
            this.resetFilter();
        },
        resetFilter() {
            this.dates = [];
            this.pagination.past.page = 0;
            this.pagination.incoming.page = 0;
            this.pagination.past.offsets = [];
            this.pagination.incoming.offsets = [];
            this.pagination.past.seeMore = false;
            this.pagination.incoming.seeMore = false;
            this.logs = [];
            this.incomingLogs = [];
            this.fetch();
            this.fetchCounters();
        },
        checkTab() {
            if (this.newFilters.currentTab === 'activity') {
                this.showFilter = true;
            } else {
                this.showFilter = false;
            }
        },
        addLogs(logs) {
            if (logs.incoming !== undefined && logs.incoming.length > 0) {
                for (var i in logs.incoming) {
                    this.addIncomingLog(logs.incoming[i]);
                }
            }

            if (logs.past !== undefined && logs.past.length > 0) {
                for (const i in logs.past) {
                    this.addLog(logs.past[i]);
                }
            }
        },
        addLog(newLog) {
            const isMockedLog = newLog.mocked;
            const passesFilterCheck = this.checkActivityFilters(newLog);

            if (isMockedLog || (passesFilterCheck && this.newFilters.currentTab !== 'pinned')) {
                this.logs.push(newLog);

                if (!isMockedLog && this.newFilters.currentTab === 'pinned') {
                    this.updateDisplayedTabCounter(newLog.objecttype, 1);
                }

                this.$forceUpdate();
            }
        },
        async addMockedLog(payload) {
            try {
                const author = this.getUser;

                if (author) {
                    const log = {
                        cardType: 'object',
                        card: 'email',
                        timestamp: Date.now() / 1000,
                        event: 'emailengine.sent',
                        activityFilters: [
                            'emailengine.null',
                            'third.1',
                            'people.5',
                            'thirdcontact.1',
                            'staff.1',
                        ],
                        pin: null,
                        idES: null,
                        icon: 'emailengine.sent',
                        objecttype: 'emailengine',
                        objectid: null,
                        mocked: true,
                        linkeds: [],
                        owner: {
                            id: '1',
                            peopleid: '1',
                            status: 'ok',
                            type: 'staff',
                            fullName: `${author.forename} ${author.name}`,
                            name: author.forename,
                            forename: author.name,
                            email: author.senderEmail,
                            tel: author.phoneNumber,
                            mobile: author.phoneNumber,
                            position: '',
                            avatar: {
                                type: 'initials',
                                value: author.forename[0],
                                class: 0,
                            },
                            staffid: '1',
                            permission: true,
                        },
                        email: {
                            scheduled: false,
                            subject: payload.subject,
                            attachments: payload.attachments,
                            provider: 'nylas',
                            threadId: null,
                            messageId: null,
                            description: payload.content,
                            status: 'sent',
                            isOpen: false,
                            from: {
                                email: '',
                                name: null,
                            },
                        },
                        displayDate: false,
                        displayYear: false,
                    };
                    this.addLog(log);
                }
            } catch (error) {
                console.error(error);
            }
        },
        addIncomingLog(newLog) {
            if (this.checkActivityFilters(newLog)) {
                if (this.newFilters.currentTab !== 'pinned') {
                    this.incomingLogs.push(newLog);
                } else {
                    this.updateDisplayedTabCounter(newLog.objecttype, 1);
                }
                this.$forceUpdate();
            }
        },
        adaptAnnotation(annotation) {
            const activityFilter = [
                `annotation.${annotation.id}`,
                `${annotation.related[0].type}.${annotation.related[0].id}`,
                `${annotation.owner.type}.${annotation.owner.id}`,
            ];
            let log = {
                activityFilter,
                cardType: 'object',
                card: 'annotation',
                timestamp: new Date(annotation.created).getTime() / 1000,
                event: 'annotation.created',
                objecttype: 'annotation',
                objectid: annotation.id,
                owner: annotation._embed.owner,
                content: annotation.description,
                can_edit: true,
                can_delete: true,
                replies: [],
            };
            log.owner.fullName = getFullNameUser({
                firstname: log.owner.firstname,
                lastname: log.owner.lastname,
            });

            if (annotation.timetracking) {
                const format =
                    annotation.timetracking.duration >= 3600
                        ? `HH [${this.$l10n.__('heures')}] mm [${this.$l10n.__('minutes')}]`
                        : `mm [${this.$l10n.__('minutes')}]`;

                const stringDurationTimetrackingWithText = moment()
                    .startOf('day')
                    .second(annotation.timetracking.duration)
                    .format(format);
                const stringDurationTimetracking = moment()
                    .startOf('day')
                    .second(annotation.timetracking.duration)
                    .format('HH:mm:ss');

                const timetracking = {
                    timeFormatted: stringDurationTimetrackingWithText,
                    time: stringDurationTimetracking,
                    service: annotation.timetracking.name,
                    serviceid: annotation.timetracking.service,
                    format: format,
                };
                log = { ...log, timetracking };
            }
            this.addLog(log);
        },
        checkActivityFilters(log) {
            return (
                log.activityFilters === undefined ||
                log.activityFilters.includes(this.getLinkedType() + '.' + this.linkedid) ||
                this.excludeLogTypesFromCheck.includes(log.event)
            );
        },
        deleteLog(logType, index, objectType = null) {
            if (this.newFilters.currentTab === 'pinned') {
                this.updateDisplayedTabCounter(objectType, -1);
            }
            if (logType === 'incoming') {
                if (this.incomingLogs[index]?.pin) {
                    this.updateDisplayedTabCounter('pinned', -1);
                }

                this.incomingLogs.splice(index, 1);
            } else {
                if (this.logs[index]?.pin) {
                    this.updateDisplayedTabCounter('pinned', -1);
                }

                try {
                    const commentsTohighlight =
                        this.$refs['comment' + this.$route.query.comment][0];
                    commentsTohighlight.$el.classList.remove('highlighted');
                    const emailsTohighlight = this.$refs['email' + this.$route.query.email][0];
                    emailsTohighlight.$el.classList.remove('highlighted');
                } catch (e) {}
                this.logs.splice(index, 1);
            }
        },
        updateDisplayedTabCounter(counterType, addedValue) {
            const type = counterType === 'annotation' ? 'note' : counterType;
            this.counters[type].count += addedValue;
        },
        refreshLog(logType, index) {
            var log = logType === 'incoming' ? this.incomingLogs[index] : this.logs[index];
            var eventDetails = log.eventDetails ? log.eventDetails : {};
            window.SellsyJS.WebServiceCaller.post(
                `/timeline/process/${this.getLinkedType()}/${this.linkedid}/${log.event}/${
                    log.objectid
                }`,
                {},
                { eventDetails: eventDetails },
                (response) => {
                    if (!response.incoming && !response.past) {
                        return;
                    }

                    if (response.incoming && response.incoming.length > 0) {
                        log = response.incoming[0];
                        if (!this.logBelongToEntity(log)) {
                            this.deleteLog(logType, index);
                        } else if (logType === 'incoming') {
                            this.incomingLogs.splice(index, 1, log);
                        } else {
                            //Move past log to incoming log
                            this.logs.splice(index, 1);
                            this.incomingLogs.push(log);
                        }
                    } else if (response.past && response.past.length > 0) {
                        log = response.past[0];
                        if (!this.logBelongToEntity(log)) {
                            this.deleteLog(logType, index);
                        } else if (logType === 'past') {
                            this.logs.splice(index, 1, log);
                        } else {
                            //Move incoming log to past log
                            this.incomingLogs.splice(index, 1);
                            this.logs.push(log);
                        }
                    }
                },
            );
        },
        logBelongToEntity(log) {
            return log.activityFilters.indexOf(`${this.getLinkedType()}.${this.linkedid}`) !== -1;
        },

        fetchPresetFilters() {
            this.loader = true;
            axios
                .get('/timeline/presetfilters', {
                    params: {
                        linkedtype: this.linkedtype,
                    },
                })
                .then((response) => {
                    // remove entities if plugin not active
                    this.checkPluginTabs(response.data.entities);
                    // group entities + check default entities + check default value + remove entities if plugin not active
                    this.groupEntities(response.data);
                    // group filters
                    this.groupFilters(response.data);

                    this.error = {};

                    if (!this.forceTab && !this.forceTimelineFiltersTabs && !this.isDocument) {
                        this.activeTab = response.data.currentTab;
                    }
                    this.presetDate = response.data.presetDate[1];

                    // Entities
                    let entitiesActive = [];
                    if (this.activeTab !== 'activity') {
                        entitiesActive = this.tabs.find(
                            (tab) => tab.value === this.activeTab,
                        )?.entities;
                    } else {
                        entitiesActive = this.getCheckedEntities();
                    }

                    this.filtersReady = true;

                    const filters = {
                        entities: entitiesActive,
                        filters: {
                            ...this.getSettedFilters(),
                            events:
                                this.activeTab === 'email' &&
                                !this.activeEmailFilter.includes('all') // in case of all, the backend requires an empty string
                                    ? this.activeEmailFilter
                                    : null,
                        },
                        currentTab: this.activeTab,
                        end: this.presetDate ? this.presetDate : '',
                        start: '',
                    };

                    this.applyFilter(filters);
                })
                .catch((error) => {
                    Push.error(
                        this.$l10n.__(
                            'Une erreur est survenue lors de la récupération des filtres. Veuillez ré-essayer dans quelques minutes.',
                        ),
                        false,
                    );
                    this.error = error?.response?.data?.error;
                    this.loader = false;
                });
        },
        groupEntities(response) {
            if (response.entities.length > 0) {
                this.entitiesGroups.map((group) => {
                    if (group.entities.length > 0) {
                        const entitiesIndexToRemove = [];
                        group.entities.map((entityName, entityIndex) => {
                            if (typeof entityName === 'object' && entityName !== null) {
                                entityName = entityName.value;
                            }
                            // get entity from response
                            const entityFound = response.entities.find(
                                (oneEntity) => oneEntity.value === entityName,
                            );
                            if (entityFound) {
                                // get entity from TimelineEntities.js
                                const newEntity = this.entities.find(
                                    (entity) => entity.value === entityName,
                                );
                                if (response.useDefault) {
                                    newEntity.checked = this.defaultEntities.includes(
                                        newEntity.value,
                                    );
                                } else {
                                    newEntity.checked = entityFound.checked ? true : false;
                                }
                                group.entities[entityIndex] = newEntity;
                            } else {
                                entitiesIndexToRemove.push(entityIndex);
                            }
                        });
                        if (entitiesIndexToRemove.length > 0) {
                            for (var i = entitiesIndexToRemove.length - 1; i >= 0; i--)
                                group.entities.splice(entitiesIndexToRemove[i], 1);
                        }
                    }
                });
                return;
            }
        },
        groupFilters(response) {
            if (response.filters.length) {
                return;
            }
            this.entitiesGroups
                .filter((c) => c.filter)
                .map((group) => {
                    group.selected = [];
                    const filterFound = response.filters[group.value];
                    if (!filterFound) {
                        return;
                    }
                    group.selected = filterFound;
                });
        },
        checkPluginTabs(entities) {
            if (entities.length > 0) {
                this.tabs.map((tab) => {
                    if (tab.entities.length > 0) {
                        const entitiesIndexToRemove = [];
                        tab.entities.map((entityName, entityIndex) => {
                            const entityFound = entities.find(
                                (oneEntity) => oneEntity.value === entityName,
                            );
                            if (!entityFound) {
                                entitiesIndexToRemove.push(entityIndex);
                            }
                        });
                        if (entitiesIndexToRemove.length > 0) {
                            for (var i = entitiesIndexToRemove.length - 1; i >= 0; i--)
                                tab.entities.splice(entitiesIndexToRemove[i], 1);
                        }
                    }
                });
            }
        },
        getCheckedEntities() {
            const entitiesChecked = [];
            this.entitiesGroups.map((group) => {
                group.entities.map((entity) => {
                    if (entity.checked) {
                        entitiesChecked.push(entity.value);
                    }
                });
            });

            return entitiesChecked;
        },
        getSettedFilters() {
            const setted = {};
            this.entitiesGroups
                .filter((one) => one.filter)
                .map((one) => {
                    if (Array.isArray(one.selected) && one.selected.length > 0) {
                        setted[one.value] = one.selected;
                    }
                });
            return setted;
        },
        forceLabelEntities() {
            this.entities.map((entity) => {
                const oneEntity = this.forcedLabel.find(
                    (forcedEntity) => entity.value === forcedEntity.value,
                );
                if (oneEntity) {
                    entity.label = oneEntity.label;
                }
            });
        },
        getLinkedType() {
            var type = this.linkedtype;
            switch (this.linkedtype) {
                case 'client':
                case 'supplier':
                case 'prospect':
                    type = 'third';
                    break;
            }
            return type;
        },
        onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            if (this.linkedtype === 'staff') {
                if (scrollTop + clientHeight >= scrollHeight) {
                    EventBus.emit('timeline:fetch-past-log');
                }
            }
        },
        isOverflowing(logs) {
            const lastCard = _.last(logs);
            return lastCard.hasOwnProperty('staffs') && lastCard.staffs.params.list.length > 1;
        },
        highlightCard(type, id) {
            try {
                const ref = type + '.' + id;
                const cardTohighlight = this.$refs[ref][0];
                cardTohighlight.$el.classList.add('highlighted');
                cardTohighlight.$el.scrollIntoView({ block: 'center', behavior: 'smooth' });
            } catch (e) {
                EventBus.emit('timeline:fetch-past-log');
            }
        },
        togglePin(data) {
            this.updateLog(data);
        },
    },
};
</script>
<style lang="scss" scoped>
.cd-container.timeline-container {
    overflow: visible;
}
</style>
<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.timeline-container {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 0 0 var(--spacing-4);
}

.cd-timeline-more {
    position: relative;

    div {
        p::before {
            content: '\25CF';
            position: absolute;
            left: 11px;
            font-size: 12px;
            color: #17242c;
        }
    }
}
.cd-timeline-day {
    &-wrapper {
        margin: 0 0 var(--spacing-3);
    }

    &-label {
        padding: 1px 7px;
        border: solid 1px $gray-05;
        border-radius: 20px;
        background-color: $secondary-blue;
        width: fit-content;
        color: $white;

        span {
            line-height: 16px;
            font-size: 12px;
            text-transform: uppercase;
        }
    }
}

#cd-timeline {
    .cd-timeline--overflow {
        overflow-y: visible;
    }

    .past-events {
        position: relative;
        overflow: visible;
    }

    .cd-timeline-log {
        position: relative;
        margin: 0 0 var(--spacing-1);

        &.cd-timeline-log--day:not(.cd-timeline-log--object),
        &.cd-timeline-log--annual:not(.cd-timeline-log--object) {
            margin-bottom: 8px;

            .cd-timeline-block {
                position: relative;
                margin-top: var(--spacing-0);
            }
        }

        &--title {
            position: relative;
        }

        .cd-timeline-block {
            align-items: flex-start;
        }

        .timeline-icon {
            &::before {
                content: ' ';
                position: absolute;
                left: 16px;
                top: 36px;
                height: calc(100% - 36px);
                border-left: solid 1px var(--colors-component-border-actionable-default);
            }
        }
    }

    .annual-line {
        font-size: 17px;
        line-height: 24px;
        font-weight: $font-weight-bold;
        color: $gray-80;
        margin: var(--spacing-1) 0;
    }
}

.cd-timeline-content-text {
    color: $gray-80;
    line-height: 20px;
    font-weight: 400;
}

.timeline-overflow-y {
    overflow-y: visible !important;
}

.timeline-filters {
    margin-bottom: var(--spacing-3);
}
</style>
<style lang="scss" scoped>
.cd-timeline-block .cd-timeline-content {
    margin: 0 var(--spacing-0) 0 var(--spacing-3);
    padding: 0 0 var(--spacing-4);
}
</style>
